module.exports = __webpack_public_path__ + "static/backyard-nav-d72d2c6e7fe961bf73fd23b78be59a23.jpeg";